// lib
import { createAction } from "@reduxjs/toolkit";

export const updateTimelineWindow = createAction("timeline/window/update");
